import { data } from '../../svg/DoubleThumbsUp/data';
import { makeIcon } from '../makeIcon';

export const DoubleThumbsUp = makeIcon(data, 'double_thumbs_up', 'DoubleThumbsUp');

export default DoubleThumbsUp;
